import Table from "react-bootstrap/Table";
import { AxisDateTimeFull } from "../util/AxisDateTime";
import React, { Fragment, useState } from "react";
import EmailModal from "../modals/EmailModal";
import UserMessageModal from "../modals/UserMessageModal";
import { UserLink } from "../util/Links";
import { ShiftTableTitle } from "./ShiftTableTitle";

const ShiftAuditTrailElement = ({ shift }) => {
  const [showEmail, setShowEmail] = useState(false);
  const [emailData, setEmailData] = useState(null);
  const [showMessage, setShowMessage] = useState(false);
  const [messageData, setMessageData] = useState(null);
  const [postmarkData, setPostmarkData] = useState(null);

  if (shift === null || shift === undefined) return;

  const handleEmailClose = () => setShowEmail(false);

  const handleEmailOpen = (audit) => {
    setEmailData(audit?.email);
    setPostmarkData(audit?.postMarkMessageId);
    setShowEmail(true);
  };

  const handleMessageClose = () => setShowMessage(false);

  const handleMessageOpen = (message) => {
    setMessageData(message);
    setShowMessage(true);
  };
  return (
    <Fragment>
      <ShiftTableTitle title={"Audit Trail"} />
      <Table striped hover responsive>
        <thead>
          <tr>
            <th>Status</th>
            <th>Actioned</th>
            <th>Via</th>
            <th>Reject Reason</th>
            <th>User Message</th>
            <th>Email</th>
            <th>Timestamp</th>
          </tr>
        </thead>
        <tbody>
          {shift?.auditTrail.map((audit) => (
            <tr key={audit?.id}>
              <td className={"text-capitalize"}>
                {audit?.status.replace(/_/g, " ").toLowerCase()}
              </td>
              <td>{UserLink(audit?.user)}</td>
              <td className={"text-capitalize"}>
                {audit?.actionedBy.toLowerCase()}
              </td>
              <td>{audit?.rejectReason}</td>

              {audit?.message !== null ? (
                <td
                  className={["text-decoration-none pointer text-capitalize"]}
                  onClick={() => handleMessageOpen(audit?.message)}
                >
                  <span className={"text-axis-link fw-bold"}>
                    {audit?.message?.title}
                  </span>
                </td>
              ) : (
                <td>N/A</td>
              )}

              {audit?.email != null ? (
                <td
                  className={"text-decoration-none pointer text-capitalize"}
                  onClick={() => handleEmailOpen(audit)}
                >
                  <span className={"text-axis-link fw-bold"}>
                    {audit?.email?.subject}
                  </span>
                </td>
              ) : (
                <td>N/A</td>
              )}

              <td>{AxisDateTimeFull(audit?.created)}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      <EmailModal
        visible={showEmail}
        close={handleEmailClose}
        email={emailData}
        postmark={postmarkData}
      />

      <UserMessageModal
        visible={showMessage}
        close={handleMessageClose}
        message={messageData}
      />
    </Fragment>
  );
};

export default ShiftAuditTrailElement;
